import React from 'react';
import { observer } from 'mobx-react';
import _ from 'lodash';

/**
 * 头部模板，不用显示display:none，后边会append到其他元素上。
 */
@observer
export default class TasksEditHead extends React.Component<{ganttStore}, any>{

    renderTr=()=>{
        const {ganttStore}=this.props;
        const {fields}=ganttStore;
        const trArr:any = [<th className="gdfColHeader gdfied unselectable" style={{width:'35px'}} >序号</th>];
        var clientWidth = document.body.clientWidth;
        _.forEach(fields.slice(),(item,index)=>{
            var colwidth = parseFloat(item.colwidth);
            var width = parseInt((clientWidth*colwidth*0.4)/100+'');
            if(item.systemFlag&&item.systemFlag==1){
                trArr.push(<th className="gdfColHeader gdfResizable" data-initialwidth={width} style={{ width: width+'px'}}>{item.showName}</th>);
            }else{
                trArr.push(<th className="gdfColHeader gdfResizable" style={{ width: width+'px' }}>{item.showName}</th>)
            }
        })
        return trArr;
    }
    render() {
       
        return <div id="tasksEditHead" style={{display:'none'}}>
            <table className="gdfTable" data-cellspacing="0" data-cellpadding="0">
                <thead>
                    <tr style={{ height: '60px' }}>
                        {this.renderTr()}
                    </tr>
                </thead>
            </table>
        </div>
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/gantt/TasksEditHead.tsx